import React from 'react';
import { motion } from 'framer-motion';
import { Check, Lock, ShieldCheck } from 'lucide-react';
import { RESULT_CONTENT, MetabolicType } from '../lib/constants';
import { useLocalPrice } from '../hooks/useLocalPrice';
interface BridgePageProps {
  resultType: MetabolicType;
}
export function BridgePage({
  resultType
}: BridgePageProps) {
  const content = RESULT_CONTENT[resultType];
  const {
    price,
    originalPrice,
    currency,
    loading
  } = useLocalPrice(17.99, 97);
  const features = ['Plan de alimentación personalizado', 'Plan de ejercicios de 90 días', 'Guía de hidratación', 'Guía de macros', 'Guía de compras inteligentes'];
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="flex flex-col px-4 py-8 min-h-[100dvh] bg-gray-50 max-w-md mx-auto shadow-xl overflow-y-auto hide-scrollbar" data-id="element-16">
      <div className="text-center mb-8" data-id="element-17">
        <span className="inline-block bg-green-100 text-primary text-sm font-bold px-4 py-1.5 rounded-full mb-4 uppercase tracking-wide" data-id="element-18">
          ✅ Resultado listo
        </span>
        <h1 className="text-3xl font-extrabold text-dark mb-4 leading-tight" data-id="element-19">
          Hemos preparado un plan para tu metabolismo
        </h1>
        <p className="text-gray-600 text-lg" data-id="element-20">
          Basado en tus respuestas, tu cuerpo responde mejor al plan:{' '}
          <strong className="text-primary" data-id="element-21">{content.title}</strong>
        </p>
      </div>

      <div className="bg-red-50 border border-red-100 rounded-2xl p-5 mb-6 text-center space-y-3" data-id="element-22">
        <p className="text-gray-700 text-base leading-relaxed" data-id="element-23">
          Muchas personas intentan diferentes dietas durante años… pero el
          problema no es la disciplina.
        </p>
        <p className="text-gray-800 font-semibold text-base leading-relaxed" data-id="element-24">
          El problema es seguir un plan que{' '}
          <strong className="text-red-600" data-id="element-25">
            no coincide con su metabolismo.
          </strong>
        </p>
        <p className="text-primary font-bold text-base" data-id="element-26">
          Por eso preparamos un plan específico para tu metabolismo.
        </p>
      </div>

      <div className="bg-white rounded-3xl shadow-lg border border-gray-100 overflow-hidden mb-6" data-id="element-27">
        <div className="bg-primary text-white text-center py-3 font-bold tracking-wide text-sm uppercase" data-id="element-28">
          Tu Programa Incluye
        </div>
        <div className="p-6" data-id="element-29">
          <ul className="space-y-4" data-id="element-30">
            {features.map((feature, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-start gap-3" data-id="element-31">
                <div className="bg-green-100 rounded-full p-1 mt-0.5" data-id="element-32">
                  <Check className="w-4 h-4 text-primary" strokeWidth={3} data-id="element-33" />
                </div>
                <span className="text-gray-700 font-medium" data-id="element-34">{feature}</span>
              </motion.li>)}
          </ul>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-2xl p-4 mb-8 flex items-start gap-3" data-id="element-35">
        <div className="bg-secondary/10 p-2 rounded-full text-secondary" data-id="element-36">
          <Lock className="w-5 h-5" data-id="element-37" />
        </div>
        <div data-id="element-38">
          <h4 className="font-bold text-dark text-sm mb-1" data-id="element-39">
            Asistente metabólico inteligente (opcional)
          </h4>
          <p className="text-sm text-gray-600" data-id="element-40">
            Acceso opcional a tu nutricionista y entrenador virtual 24/7. Haz
            preguntas, resuelve dudas y ajusta tus rutinas y alimentación en
            tiempo real para mantenerte siempre dentro de tu plan.
          </p>
        </div>
      </div>

      <div className="bg-white rounded-3xl shadow-lg border border-gray-100 p-6 mb-8 text-center relative overflow-hidden" data-id="element-41">
        <div className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-42">
          OFERTA HOY
        </div>
        <p className="text-gray-500 font-medium mb-2 line-through" data-id="element-43">
          Valor normal: {loading ? '...' : originalPrice}
        </p>
        <p className="text-gray-800 font-bold mb-1" data-id="element-44">
          Acceso completo hoy por solo:
        </p>
        <div className="text-5xl font-black text-primary mb-3" data-id="element-45">
          {loading ? '...' : price}
        </div>
        <p className="text-xs text-gray-400 italic" data-id="element-46">
          Precio especial disponible hoy para nuevos usuarios del test.
        </p>

        <motion.button whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="w-full bg-primary text-white text-lg font-bold py-3.5 rounded-full shadow-lg shadow-primary/30 hover:bg-[#249e63] transition-colors mt-4" onClick={() => {
        if ((window as any).fbq) {
          ;
          (window as any).fbq('track', 'InitiateCheckout', {
            content_name: 'Codigo Metabolico',
            value: 17.99,
            currency: currency
          });
        }
        alert('Redirigiendo al checkout...');
      }} data-id="element-47">
          Quiero mi plan metabólico
        </motion.button>
      </div>

      <div className="bg-white rounded-2xl border border-gray-200 p-5 mb-8 w-full shadow-sm" data-id="element-48">
        <div className="text-center mb-5" data-id="element-49">
          <h3 className="text-lg font-extrabold text-dark mb-2" data-id="element-50">
            Deja de pagar por lo que no funciona.
          </h3>
          <p className="text-sm text-gray-500 leading-relaxed" data-id="element-51">
            Deja de gastar en métodos que no están diseñados para tu cuerpo.
          </p>
        </div>

        <p className="text-sm font-bold text-dark mb-3" data-id="element-52">
          Con tu programa recibes:
        </p>

        <ul className="space-y-3 text-sm text-gray-700 mb-5" data-id="element-53">
          <li className="flex items-start gap-2.5" data-id="element-54">
            <span className="text-primary text-base mt-0.5" data-id="element-55">🍽️</span>
            <span data-id="element-56">
              <strong data-id="element-57">Plan de alimentación personalizado</strong> — diseñado
              para tu tipo de metabolismo, no una dieta genérica de internet.
            </span>
          </li>
          <li className="flex items-start gap-2.5" data-id="element-58">
            <span className="text-primary text-base mt-0.5" data-id="element-59">🏋️</span>
            <span data-id="element-60">
              <strong data-id="element-61">Plan de ejercicios de 90 días</strong> — fácil de seguir,
              sin gimnasio obligatorio, adaptado a tu ritmo.
            </span>
          </li>
          <li className="flex items-start gap-2.5" data-id="element-62">
            <span className="text-primary text-base mt-0.5" data-id="element-63">🔥</span>
            <span data-id="element-64">
              <strong data-id="element-65">Guía de consumo calórico</strong> — aprende a medir lo que
              comes sin obsesionarte ni pasar hambre.
            </span>
          </li>
          <li className="flex items-start gap-2.5" data-id="element-66">
            <span className="text-primary text-base mt-0.5" data-id="element-67">💧</span>
            <span data-id="element-68">
              <strong data-id="element-69">Guía de hidratación estratégica</strong> — porque
              hidratarte bien acelera resultados más de lo que crees.
            </span>
          </li>
          <li className="flex items-start gap-2.5" data-id="element-70">
            <span className="text-primary text-base mt-0.5" data-id="element-71">🛒</span>
            <span data-id="element-72">
              <strong data-id="element-73">Guía de compras inteligentes</strong> — para que sepas
              exactamente qué comprar en el supermercado.
            </span>
          </li>
          <li className="flex items-start gap-2.5" data-id="element-74">
            <span className="text-primary text-base mt-0.5" data-id="element-75">🎯</span>
            <span data-id="element-76">
              <strong data-id="element-77">Bonos anti-abandono</strong> — herramientas para que no
              dejes el proceso a la mitad como siempre.
            </span>
          </li>
        </ul>

        <div className="bg-blue-50 border border-blue-100 rounded-xl p-3.5" data-id="element-78">
          <p className="text-sm text-gray-700 leading-relaxed" data-id="element-79">
            <strong className="text-secondary" data-id="element-80">🤖 Además:</strong> Acceso
            opcional a un <strong data-id="element-81">asistente inteligente 24/7</strong> entrenado
            exclusivamente para esto. Pregúntale lo que quieras, varía tu plan
            alimenticio y ajusta tu rutina de ejercicios según tus preferencias
            — como tener un nutricionista y entrenador en tu bolsillo.
          </p>
        </div>
      </div>

      <div className="mt-auto w-full flex flex-col items-center gap-4 pb-4" data-id="element-82">
        <motion.button whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="w-full bg-primary text-white text-xl font-bold py-4 rounded-full shadow-xl shadow-primary/30 hover:bg-[#249e63] transition-colors" onClick={() => {
        if ((window as any).fbq) {
          ;
          (window as any).fbq('track', 'InitiateCheckout', {
            content_name: 'Codigo Metabolico',
            value: 17.99,
            currency: currency
          });
        }
        alert('Redirigiendo al checkout...');
      }} data-id="element-83">
          Quiero mi plan metabólico
        </motion.button>

        <div className="flex flex-wrap justify-center gap-3 text-gray-400 text-xs font-medium" data-id="element-84">
          <span className="flex items-center gap-1" data-id="element-85">✔ Acceso inmediato</span>
          <span className="flex items-center gap-1" data-id="element-86">
            <ShieldCheck className="w-3.5 h-3.5" data-id="element-87" /> Pago seguro vía Hotmart
          </span>
          <span className="flex items-center gap-1" data-id="element-88">
            📥 Contenido digital descargable
          </span>
        </div>
      </div>
    </motion.div>;
}